import '@/styles/globals.css';
import '@/styles/flickity.css';
import { useEffect } from 'react';
import type { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import { Customer } from '@/types/storefront';
import { useCustomerStore } from 'stores/useCustomerStore';
import { useCategoryStore } from 'stores/useCategoryStore';

function App({ Component, pageProps }: AppProps) {
  const router = useRouter();

  useEffect(() => {
    async function fetchCategories() {
      const response = await fetch('/api/categories');
      let categories = await response.json();

      // explicitly move make-up to 2nd place in the array
      const makeup = categories.find((category: any) => category.handle === 'make-up');
      categories = categories.filter((category: any) => category.handle !== 'make-up');
      categories.splice(1, 0, makeup);

      useCategoryStore.setState({ categories });
    }
    fetchCategories();
  }, []);

  useEffect(() => {
    fetch('/api/customer')
      .then((res) => res.json())
      .then((data: { customer: Customer }) => {
        useCustomerStore.setState({ customer: data.customer });
      });
  }, []);

  useEffect(() => {
    const handleRouteChange = (path: string) => {
      gtag('event', 'page_view', {
        page_location: window.location.href,
        page_title: document.title
      })
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => router.events.off('routeChangeComplete', handleRouteChange);
  }, [router]);

  return (
    <Component {...pageProps} />
  );
}

export default App;
